import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const AdminRoute = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuth();

  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/auth" replace />;
  if (!Array.isArray(user?.roles) || !user.roles.includes("admin"))
    return <Navigate to="/" replace />;

  return children;
};

export default AdminRoute;
